import { useNavigation } from 'src/hooks/useNavigation'

export const useAppBreadcrumb = () => {
  const { navigateTo } = useNavigation()

  return { navigateTo }
}
